// i18next bootstrap.
//
// Two namespaces: `common` (UI chrome) and `auth` (login + sign-up + OTP).
// Add a new namespace by dropping a JSON file under locales/<lang>/<ns>.json
// and listing it in `ns` below + `defaultNS` if it should be the fallback.
//
// LanguageDetector chain: querystring (?lng=fr) -> localStorage -> navigator.
// Querystring takes priority so it's easy to test FR without changing browser.

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import frCommon from './locales/fr/common.json';
import frAuth from './locales/fr/auth.json';
import frStudio from './locales/fr/studio.json';
import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enStudio from './locales/en/studio.json';
import frNova from './locales/fr/nova.json';
import enNova from './locales/en/nova.json';

await i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en'],
    ns: ['common', 'auth', 'studio', 'nova'],
    defaultNS: 'common',
    interpolation: { escapeValue: false }, // React already escapes
    resources: {
      fr: { common: frCommon, auth: frAuth, studio: frStudio, nova: frNova },
      en: { common: enCommon, auth: enAuth, studio: enStudio, nova: enNova },
    },
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lng',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
  });

export default i18n;
